<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-11 18:51:05
 -->
<template>
  <el-container>
    <el-container>
      <el-header>
        <Header />
      </el-header>
      <el-main>
        <div class="mod-index">
           <router-view />
        </div>
      </el-main>
      <el-footer>
        <Footer />
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
import Header from './Header'
import Footer from "./Footer";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
    };
  },
};
</script>
<style lang="stylus" scoped>
/deep/.el-header
  padding: 0
.mod-index
  border-radius: 5px
  background: #fff
  padding: 24px
  min-height: 800px
  line-height: 1.5
  p
    margin: 0;
  h3
    margin-block-start: 0
    margin-block-end: 0.5em

  .xm-gt img
    height: 240px
    margin-left: -16px
  .jx-zz img
    height: 400px
    margin-top: 24px
    margin-right: 24px
</style>


